export default class EventTicketsTabs {
    constructor($el) {
        this.$filters = $el.querySelectorAll('[data-event-tickets-tabs-filter]');
        this.$lists = $el.querySelectorAll('[data-event-tickets-tabs-list]');

        if ( ! this.$lists.length ||  ! this.$filters.length) {
            return;
        }

        this.toggleActiveList = this.toggleActiveList.bind(this);

        this.activeFilter = this.$filters[0].dataset.eventTicketsTabsFilter;
        this.toggleActiveList()
        this.$filters[0].classList.add('active');

        this.$filters.forEach($filter => {
            $filter.addEventListener('click', (e) => {
                e.preventDefault();

                this.activeFilter = $filter.dataset.eventTicketsTabsFilter;
                this.toggleActiveList();

                this.$filters.forEach(f => {
                    f.classList.remove('active');
                });

                $filter.classList.add('active');
            });
        });
    }

    toggleActiveList() {
        const $newActiveList = Array.from(this.$lists).find(x => x.dataset.eventTicketsTabsList === this.activeFilter);

        this.$lists.forEach(list => {

            list.classList.remove('active');
        });

        $newActiveList.classList.add('active');
    }
}